import Barba from 'barba.js'
import Env from '../base/env.js'
import Channels from '../base/channels'
import SSHorizontal from '../components/single/SSHorizontal'
import PlayerCustom from '../components/single/PlayerCustom'
import FlowWaypoints from '../components/FlowWaypoints'
import Splashscreen from '../components/single/Splashscreen'
import raf from 'raf'
import 'babel-polyfill'

let page

class Page
{
    constructor(view='')
    {
        // Dom
        this.view = view
        this.$progress = this.view.querySelector('.jsProgress')
        this.classView = 'currentView--single'
        // Objects
        this.modulesSlideshow = false
        this.raf = undefined
        // States
        this.uiViewportGap = (Env.ios === true)?75:0
        // Flags
        this.CAN_CHECK_NEXT = false
        this.IS_NEXT_CHECKING = false
        this.IS_WATCHING = true
        // Timers
        this.timerNext = false
        // Fns
        this.setup()
        // Launch Fn
        this.funcLaunch = this.intro.bind(this)
        if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()
    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    destroy()
    {
        for(const module of this.modulesSlideshow){
            module.destroy()
        }
        this.player.destroy()
        this.waypoints.destroy()
        raf.cancel(this.raf)
        Channels.removeListener('launcher::exit', this.funcLaunch);
    }

    events()
    {
        if(this.CAN_CHECK_NEXT === true) {
            this.view.querySelector('.jsScrollNext--link').addEventListener('click',()=>{
                Env.framework.UI.launchAfter()
            })
        }


    }

    finalize()
    {
        this.modulesSlideshow = this.slideshow()
        this.player = new PlayerCustom(this.view)
        this.splashcreen = new Splashscreen(this.view.querySelector('.jsSplashscreen--view'))
        this.splashcreen.unlocked()
        setTimeout(() => {
            if(Env.isVisiting === true) {
                this.intro()
            }
        }, 100);
        setTimeout(()=>
        {
            this.waypoints = new FlowWaypoints(this.view)
        },200)
        this.watcher()
    }

    intro()
    {
        const $cover = this.view.querySelector('.fxCover')
        const $bg = (Env.mobileCSS === true)?$cover.querySelector('.bg-mobile'):$cover.querySelector('.bg')
        const dimensionsBg = $bg.getBoundingClientRect()

        let timeline = new TimelineLite()
        timeline.add([
            TweenLite.fromTo($bg , 1 , { clip : `rect(0px,${dimensionsBg.width}px,${dimensionsBg.height}px,${dimensionsBg.width}px)` , opacity: 1 } , { clip : `rect(0px,${dimensionsBg.width}px,${dimensionsBg.height}px,0px)` , ease : Power3.easeInOut }),
        ])
        timeline.add([
            TweenLite.fromTo($bg , 1.8 , { scale : 1.1 } , { scale : 1 , ease : Power3.easeOut }),
        ],'-=.7')
        timeline.add(()=>{
            $cover.classList.add('is--shown')
            TweenLite.set($bg , { clearProps : 'clip' })
        })
    }

    setup()
    {
        if(this.view.querySelector('.jsScrollNext--view') !== null) {
            this.CAN_CHECK_NEXT = true
        }
        this.events()
    }

    slideshow()
    {
        let modules = []
        for(const $ref of this.view.querySelectorAll('.jsSSHorizontal--view')){
            const module = new SSHorizontal($ref , { start : 0 })
            modules.push(module)
        }
        return modules
    }


    watcher()
    {
        this.raf = raf(()=>{
            this.watcher()
        })

        if(this.IS_WATCHING) {
            // Scroll progress bar
            const scroll = Env.framework.toolbox.scrollPosition()
            const ratio = scroll.scrollY / (scroll.fullPageHeight - this.uiViewportGap)
            TweenLite.set(this.$progress , { scaleX : ratio })
            // Next checking
            if(this.CAN_CHECK_NEXT === true && ratio >= 1 && this.IS_NEXT_CHECKING === false) {
                this.IS_NEXT_CHECKING = true
                this.timerNext = setTimeout(() => {
                    this.view.querySelector('.jsScrollNext--link').click()
                }, 1200);
            } else if(ratio < 1 && this.IS_NEXT_CHECKING === true) {
                this.IS_NEXT_CHECKING = false
                clearTimeout(this.timerNext)
            }
            // Mod Slideshow
            for(let mod of this.modulesSlideshow) {
                mod.onWatch()
            }
            // Splashscreen
            this.splashcreen.onWatch()
        }
    }

}

page = Barba.BaseView.extend({
    namespace: 'single',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {
        this.node.finalize()
    },
    onLeave: function()
    {
        this.node.destroy()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;